// extracted by mini-css-extract-plugin
export default {"lessongrid":"lessongrid_lessongrid__-NBx-","sectionbox":"lessongrid_sectionbox__MLeuz","sectionimage":"lessongrid_sectionimage__Ys6Kv"};